/* CasMarkt v2.2 — C2 item 5. Owned by sections/cm-video-rail.liquid, which is
   the only file that loads it (deferred).

   Three jobs, all of them things the owner asked for on the "See it up close"
   band:

   1. Expand. "When I click a video to expand it, it doesn't expand" — there
      was nothing to expand into. Clicking a clip now opens a lightbox: navy
      scrim, the video centred at up to 80vh with real controls and its sound
      on. A poster-only card has no video to expand, so its media is a plain
      <a> to the collection it advertises and never reaches this file.

   2. Links. "The links on this section don't work." The rail's drag-to-scroll
      guard in cm-animations.js cancels the click that follows any press it
      thinks was a drag — three pixels of mouse jitter while clicking is
      enough. See disarmDragGuard() below; the fix stays on this side of the
      fence because cm-animations.js belongs to another pass.

   3. Hover. The clip starts playing (muted) as soon as the pointer lands on
      the card, instead of waiting for the scroll observer.

   Motion is opacity + transform only and the scale is dropped under
   prefers-reduced-motion. */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var FADE = 220;

  var box = null;
  var dialog = null;
  var stage = null;
  var caption = null;
  var closeButton = null;
  var opener = null;
  var sourceCard = null;
  var closeTimer = null;
  var lockedByUs = false;

  function each(root, selector, fn) {
    var nodes = root.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) fn(nodes[i], i);
  }

  function svg(paths) {
    return (
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' + paths + '</svg>'
    );
  }

  /* --- the lightbox ------------------------------------------------------ */

  function build() {
    if (box) return box;

    box = document.createElement('div');
    box.className = 'cm-vbox';
    box.setAttribute('data-cm-vbox', '');
    box.hidden = true;
    box.innerHTML =
      '<div class="cm-vbox__scrim" data-cm-vbox-scrim></div>' +
      '<div class="cm-vbox__dialog" role="dialog" aria-modal="true" aria-label="Video">' +
      '<button class="cm-vbox__close" type="button" data-cm-vbox-close aria-label="Close video">' +
      svg('<path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>') +
      '</button>' +
      '<div class="cm-vbox__stage" data-cm-vbox-stage></div>' +
      '<p class="cm-vbox__caption" data-cm-vbox-caption></p>' +
      '</div>';

    document.body.appendChild(box);

    dialog = box.querySelector('.cm-vbox__dialog');
    stage = box.querySelector('[data-cm-vbox-stage]');
    caption = box.querySelector('[data-cm-vbox-caption]');
    closeButton = box.querySelector('[data-cm-vbox-close]');

    closeButton.addEventListener('click', close);
    box.querySelector('[data-cm-vbox-scrim]').addEventListener('click', close);

    box.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab') return;

      // Keep Tab inside the dialog while it owns the screen.
      var stops = dialog.querySelectorAll('button, video, a[href]');
      if (!stops.length) return;
      var first = stops[0];
      var last = stops[stops.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    return box;
  }

  function lockScroll(on) {
    if (on) {
      if (document.body.classList.contains('overflow-hidden')) return;
      document.body.classList.add('overflow-hidden');
      lockedByUs = true;
      return;
    }
    if (!lockedByUs) return;
    document.body.classList.remove('overflow-hidden');
    lockedByUs = false;
  }

  function open(card, trigger) {
    var inline = card.querySelector('video');
    if (!inline) return;

    var src = inline.currentSrc;
    if (!src) {
      var source = inline.querySelector('source');
      src = (source && source.getAttribute('src')) || inline.getAttribute('src') || '';
    }
    if (!src) return;

    build();
    window.clearTimeout(closeTimer);

    opener = trigger || null;
    sourceCard = card;

    // The card keeps playing behind the scrim otherwise, and its audio would
    // fight the copy that has just been unmuted.
    inline.pause();
    inline.muted = true;
    var soundButton = card.querySelector('[data-cm-sound]');
    if (soundButton) soundButton.setAttribute('aria-pressed', 'false');

    var text = card.querySelector('.cm-vcard__caption');
    caption.textContent = text ? text.textContent.trim() : '';
    caption.hidden = !caption.textContent;

    var player = document.createElement('video');
    player.className = 'cm-vbox__video';
    player.setAttribute('playsinline', '');
    player.playsInline = true;
    player.controls = true;
    player.loop = true;
    player.preload = 'auto';
    player.src = src;
    var poster = inline.getAttribute('poster');
    if (poster) player.poster = poster;
    player.muted = false;

    stage.innerHTML = '';
    stage.appendChild(player);

    box.hidden = false;
    // One forced reflow so the browser has a frame to transition FROM.
    void box.offsetWidth;
    box.classList.add('is-open');
    lockScroll(true);

    var started = player.play();
    if (started && started.catch) {
      started.catch(function () {
        // Some browsers refuse an unmuted autoplay even after a click; the
        // controls are right there, so leave it paused rather than muting the
        // thing the visitor asked to hear.
      });
    }

    closeButton.focus();
  }

  function close() {
    if (!box || box.hidden) return;

    box.classList.remove('is-open');
    lockScroll(false);

    var player = stage.querySelector('video');
    if (player) {
      player.pause();
      player.removeAttribute('src');
      player.load();
    }

    var card = sourceCard;
    sourceCard = null;

    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(
      function () {
        stage.innerHTML = '';
        box.hidden = true;
      },
      reduceMotion.matches ? 0 : FADE
    );

    if (card && !reduceMotion.matches) {
      var inline = card.querySelector('video');
      if (inline) {
        var resumed = inline.play();
        if (resumed && resumed.catch) resumed.catch(function () {});
      }
    }

    if (opener && opener.focus) opener.focus();
    opener = null;
  }

  /* --- the rail ---------------------------------------------------------- */

  /* cm-animations.js starts a drag on every pointerdown inside the track and
     cancels the following click if the pointer moved more than three pixels.
     A press that lands on a link or a button can never be a drag, so the
     guard is disarmed the moment it arms: a pointerup on the track runs its
     own endDrag(), which clears the dragging flag before any pointermove can
     set the "moved" flag that eats the click. This listener sits on the rail,
     so it runs after the track's own handler whatever order the two scripts
     load in. */
  function disarmDragGuard(rail) {
    var track = rail.querySelector('.cm-rail__track');
    if (!track) return;

    rail.addEventListener('pointerdown', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (!target.closest('a[href], button')) return;
      track.dispatchEvent(new Event('pointerup'));
    });
  }

  function initRail(rail) {
    if (rail.getAttribute('data-cm-video-ready') === '1') return;
    rail.setAttribute('data-cm-video-ready', '1');

    disarmDragGuard(rail);

    each(rail, '[data-cm-vopen]', function (button) {
      button.addEventListener('click', function (event) {
        var card = button.closest('.cm-vcard');
        if (!card) return;
        event.preventDefault();
        open(card, button);
      });
    });

    if (reduceMotion.matches) return;

    each(rail, '[data-cm-vcard]', function (card) {
      var video = card.querySelector('video');
      if (!video) return;
      card.addEventListener('pointerenter', function (event) {
        if (event.pointerType === 'touch') return;
        if (box && !box.hidden) return;
        var started = video.play();
        if (started && started.catch) started.catch(function () {});
      });
    });
  }

  function scan() {
    each(document, '[data-cm-video-rail]', initRail);
  }

  scan();
  document.addEventListener('shopify:section:load', scan);

  // The band can be removed from under an open lightbox in the theme editor.
  document.addEventListener('shopify:section:unload', function () {
    if (box && !box.hidden) close();
  });
})();
